export const MOST_VIEWS = 'MOST_VIEWS';
export const JERSEY_NUMBER = 'JERSEY_NUMBER';
export const ALPHABETICAL = 'ALPHABETICAL';
